import { render, staticRenderFns } from "./PersonalPorEstatus.vue?vue&type=template&id=860e1066&scoped=true"
import script from "./PersonalPorEstatus.vue?vue&type=script&lang=js"
export * from "./PersonalPorEstatus.vue?vue&type=script&lang=js"
import style0 from "./PersonalPorEstatus.vue?vue&type=style&index=0&id=860e1066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860e1066",
  null
  
)

export default component.exports